// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget =
  | 'go_to_my_balance'
  | 'download_statement'
  | 'view_pending_item'
  | 'view_all_orders'
  | 'pending_balance_info'

type WalletHistoryTimeOnTaskEventArgs = {
  screen: string
  duration: number
}

type WalletHistoryTimeOnTaskEventExtra = {
  screen: string
  duration: number
}

export const walletHistoryTimeOnTaskEvent = (args: WalletHistoryTimeOnTaskEventArgs) => {
  const extra: WalletHistoryTimeOnTaskEventExtra = {
    screen: args.screen,
    duration: args.duration,
  }

  return {
    event: 'wallet.time_in_payments_history',
    extra,
  }
}

type WalletBalanceTimeOnTaskEventArgs = {
  screen: string
  duration: number
  timestamp?: { utc_time_from: string; utc_time_to: string }
}

type WalletBalanceTimeOnTaskEventExtra = {
  screen: string
  duration: number
  timestamp?: { utc_time_from: string; utc_time_to: string }
}

export const walletBalanceTimeOnTaskEvent = (args: WalletBalanceTimeOnTaskEventArgs) => {
  const extra: WalletBalanceTimeOnTaskEventExtra = {
    screen: args.screen,
    duration: args.duration,
    timestamp: args.timestamp,
  }

  return {
    event: 'balance.time_in_balance_screen',
    extra,
  }
}

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs) => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}

// Source: https://github.com/vinted/dwh-schema-registry/blob/master/avro/events/user/view.avdl#L25
type ViewEventTarget = 'listing_increase_banner' | 'pending_balance'

type ViewEventArgs = {
  target: ViewEventTarget
  targetDetails?: string
  screen?: string
}

type ViewEventExtra = {
  target: ViewEventTarget
  target_details?: string
  screen?: string
}

export const viewEvent = (args: ViewEventArgs) => {
  const { target, targetDetails, screen } = args

  const extra: ViewEventExtra = {
    target,
  }

  if (targetDetails) extra.target_details = targetDetails
  if (screen) extra.screen = screen

  return {
    event: 'user.view',
    extra,
  }
}

type ViewScreenEventArgs = {
  screen: string
}

export const viewScreenEvent = (args: ViewScreenEventArgs) => {
  const { screen } = args

  const extra = {
    screen,
  }

  return {
    event: 'user.view_screen',
    extra,
  }
}

type WalletViewScreenEventArgs = {
  screen: string
  details: string | null
}

export const walletViewScreenEvent = (args: WalletViewScreenEventArgs) => {
  const { screen, details } = args

  return {
    event: 'wallet.view_screen',
    extra: { screen, details },
  }
}

type WalletViewEventArgs = {
  screen: string
  target_details: string | null
  target: string
}

export const walletViewEvent = (args: WalletViewEventArgs) => {
  const { screen, target, target_details } = args

  return {
    event: 'wallet.view',
    extra: { screen, target, target_details },
  }
}

type WalletInputEventArgs = {
  screen: string
  value: string | null
  target: string
  state: 'focus' | 'unfocus'
}

export const walletInputEvent = (args: WalletInputEventArgs) => {
  const { screen, target, value, state } = args

  return {
    event: 'wallet.input',
    extra: { screen, target, value, state },
  }
}

type WalletClickEventArgs = {
  screen: string
  target: string
  target_name: string
  target_details: string | null
}

export const walletClickEvent = (args: WalletClickEventArgs) => {
  const { screen, target, target_details, target_name } = args

  return {
    event: 'wallet.click',
    extra: { screen, target, target_details, target_name },
  }
}
